import React from 'react'

import { BookEnum } from '@interfaces/BookEnum'
import { CategoryPageProps, WithCategoryPageProps } from './interface'

const withCategoryPage = (Component: React.FC<CategoryPageProps>) => {
  function Hoc({
    category,
    categoryId,
    isEbook,
    bookType,
    tab,
    orderBy,
    secondaryType,
    advanceSearch,
  }: WithCategoryPageProps) {
    const newProps = {
      category,
      isEbook,
      bookTypeName: isEbook
        ? 'อีบุ๊ก'
        : bookType === BookEnum.MANGA
        ? 'การ์ตูน'
        : 'นิยายรายตอน',
      bookType: bookType || undefined,
      secondaryType: secondaryType || undefined,
      categoryId,
      tab,
      orderBy,
      advanceSearch,
    }
    return <Component {...newProps} />
  }

  return Hoc
}

export { withCategoryPage }
